export default "__VITE_ASSET__GhQEvwQc__"